var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSyria(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:53809)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.0342C24.8366 32.0342 32 24.8707 32 16.0342C32 7.19762 24.8366 0.0341797 16 0.0341797C7.16344 0.0341797 0 7.19762 0 16.0342C0 24.8707 7.16344 32.0342 16 32.0342Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9992 0.0341797C9.11976 0.0341797 3.25507 4.37618 0.994385 10.469H31.0041C28.7433 4.37618 22.8786 0.0341797 15.9992 0.0341797V0.0341797Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9992 32.0342C22.8786 32.0342 28.7433 27.6922 31.004 21.5994H0.994385C3.25507 27.6922 9.11976 32.0342 15.9992 32.0342Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.56081 12.2079L10.4241 14.8649H13.2181L10.9578 16.5073L11.8211 19.1644L9.56081 17.5222L7.3005 19.1644L8.16388 16.5073L5.90356 14.8649H8.6975L9.56081 12.2079Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4405 12.2079L23.3038 14.8649H26.0978L23.8374 16.5073L24.7008 19.1644L22.4405 17.5222L20.1801 19.1644L21.0435 16.5073L18.7832 14.8649H21.5771L22.4405 12.2079Z",
    fill: "#6DA544"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:53809"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0341797)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyria);
export default __webpack_public_path__ + "static/media/syria.42185334.svg";
export { ForwardRef as ReactComponent };